import type { i18n as I18n } from "i18next";
import en from "@/locales/en/games/merge-tiles.json";
import fr from "@/locales/fr/games/merge-tiles.json";

export const MERGE_TILES_NS = "games/merge-tiles";

/** Adds this game's translations to an initialised i18next instance (idempotent). */
export function registerMergeTilesTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", MERGE_TILES_NS))
    i18n.addResourceBundle("en", MERGE_TILES_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", MERGE_TILES_NS))
    i18n.addResourceBundle("fr", MERGE_TILES_NS, fr, true, true);
}
